import {isEmpty, forOwn, isArray} from "lodash";
import ActiveCache from "rapid/cache.active";
import collectionRepository from "rapid/collectionRepository";
import {reference} from "rapid/reference.helper";

class ActiveService extends ActiveCache {
	/**
	 *
	 * @param $injector
	 */
	constructor($injector) {

		"ngInject";

		super();
		this.reference = reference;

		this.$injector = $injector;

		this.$q = $injector.get("$q");
		this.$http = $injector.get("$http");
		this.notify = $injector.get("ngNotify");
		this.config = $injector.get("CONFIG");
		this.$filter = $injector.get("$filter");
		this.$log = $injector.get("$log");
		this.uri = null;
		this.block = false;

		this.translate = (key) => this.$filter("translate")(key);

		this.$get = this.activeGet;

	}

	normalizeChildrensToUris(data) {
		let dataQuery = angular.copy(data);

		Object.keys(dataQuery).map(key => {
			let dQk = dataQuery[key];
			if (!dQk) {
				return;
			}
			if (typeof dQk === "object" && dQk.hasOwnProperty("uri")) {
				dataQuery[key] = dQk.uri;
			}
		});

		return dataQuery;
	}

	/**
	 *
	 * @param url
	 * @param query
	 * @returns {Function}
	 */
	get(url = null, query = null) {
		let deferred = this.$q.defer();
		let config;
		if (query) {
			config = {
				paramSerializer: "$httpParamSerializerJQLike",
				params: query,
				cache: false
			};
		}
		this.$http
			.get(url, config)
			.then(response => {
				deferred.resolve(response.data);
			})
			.catch(errors => deferred.reject(errors));
		return deferred.promise;
	}

	/**
	 *
	 * @param url
	 * @param data
	 * @param config
	 * @returns {Function}
	 */
	post(url = null, data = null, config = {}) {
		if (false === this.block) {

			let deferred = this.$q.defer();
			this.$http
				.post(url, this.normalizeChildrensToUris(data), config)
				.then(response => {
					this.block = false;
					deferred.resolve(response.data);
				})
				.catch(errors => deferred.reject(errors));
			return deferred.promise;
		}
	}

	/**
	 *
	 * @param url
	 * @param data
	 * @returns {Function}
	 */
	put(url = null, data = null) {
		let deferred = this.$q.defer();
		this.$http
			.put(url, this.normalizeChildrensToUris(data))
			.then(response => deferred.resolve(response.data))
			.catch(errors => deferred.reject(errors));
		return deferred.promise;
	}

	/**
	 *
	 * @param url
	 * @returns {*|Function|jQuery.promise|promise.promise|b.promise|d.promise}
	 */
	delete(url) {
		let deferred = this.$q.defer();
		this.$http
			.delete(url)
			.then(response => deferred.resolve(response.data))
			.catch(errors => deferred.reject(errors));
		return deferred.promise;
	}

	/**
	 *
	 * @param uri
	 * @param search
	 * @returns {Function}
	 */
	list(uri, search) {
		return this.activeGet(uri, search);
	}

	/**
	 *
	 * @param uri
	 * @param data
	 * @returns {Function}
	 */
	create(uri, data) {
		return this.activePost(uri, data);
	}

	/**
	 *
	 * @param id
	 * @param data
	 * @returns {Function}
	 */
	update(uri, data) {
		return this.activePut(uri, data);
	}

	/**
	 *
	 * @param uri
	 * @returns {*|Function|jQuery.promise|promise.promise|b.promise|d.promise}
	 */
	destroy(uri) {
		return this.activeDelete(uri);
	}

	/**
	 *
	 * @param requestConfiguration
	 * @returns {Function}
	 */
	fetchAll(requestConfiguration) {
		return !requestConfiguration ?
			this.activeGet(this.uri).then(objects => {
				collectionRepository.collection[this.uri] && delete collectionRepository.collection[this.uri];
				collectionRepository.collection[this.uri] = this.reference.create(
					collectionRepository.collection[this.uri],
					objects
				);
			}) :
			this.$search(
				this.uri,
				requestConfiguration,
				this.uri
			);
	}

	/**
	 *
	 * @param key
	 * @returns {Function}
	 */
	init(key) {
		let deferred = this.$q.defer();
		if (isEmpty(this[key])) {
			return this.fetchAll();
		} else {
			deferred.resolve(this[key]);
		}
		return deferred.promise;
	}

	$search(baseUri, requestConfiguration, referenceName) {

		!referenceName && (referenceName = baseUri);

		let additional = "?query={}", uri, isBoolean = (value) => typeof(value) === "boolean" ? value : `"${value}"`;

		let getFilters = () => {
			let filter = "";
			forOwn(requestConfiguration.filter, (value, key) => {
				if (value !== null) {
					filter += `"${key}": ${isBoolean(value)},`;
				}
			});
			return filter.slice(0, -1);
		};

		try {

			if (requestConfiguration.search) {
				additional = `?query={"_global": "${requestConfiguration.search}"}`;
			}

			if (requestConfiguration.filter) {
				additional = `?query={${getFilters()}}`;
			}

			if (requestConfiguration.search && requestConfiguration.filter) {
				additional = "?query={" +
					`"_global": "${requestConfiguration.search}",`
					+ getFilters() +
					"}";
			}

			if (requestConfiguration.order) {
				additional = `${additional}&order=${requestConfiguration.order}`;
			}

			if (requestConfiguration.limit) {
				additional = `${additional}&limit=${requestConfiguration.limit}`;
			}

			if (requestConfiguration.cursor) {
				additional = `${additional}&with_cursor=1`;
			}

			uri = requestConfiguration.search ? baseUri + additional : (requestConfiguration.next_uri ? requestConfiguration.next_uri : baseUri + additional );

		} catch (e) {
			uri = baseUri;
		}

		return this
			.activeGet(uri)
			.then(response => {
				try {
					if (requestConfiguration.order || requestConfiguration.search) {
						collectionRepository.collection[referenceName] = [];
						requestConfiguration.order = null;
					}
					if (response.objects && !response.objects.length) {
						collectionRepository.collection[referenceName] = [];
					} else {
						collectionRepository.collection[referenceName] = this.reference.create(collectionRepository.collection[referenceName], (response.objects ? response.objects : response), this.channelCallbacks || null);
					}
					return response;
				} catch (e) {
					this.$log.error(e);
				}
			});

	}

	getObjects(uri) {
		return collectionRepository.collection[uri || this.uri];
	}

	$push(data, uri) {
		!collectionRepository.collection[uri || this.uri] && (collectionRepository.collection[uri || this.uri] = []);
		let updateCollectionRepository = (entity) => collectionRepository.collection[uri || this.uri].push(entity);
		if (isArray(data)) {
			data.map(entity => updateCollectionRepository(entity));
			return;
		}
		updateCollectionRepository(data);
	}

}

export default ActiveService;



// WEBPACK FOOTER //
// ./rapid/service.active.js